import React from 'react';

import PropTypes from 'prop-types';

import { localize } from 'wanderu-i18n';

import { DropdownMenu } from '../MenuTypes';
import {
    VerticalMenu,
    VerticalMenuItem,
} from '../MenuTypes/VerticalMenu/VerticalMenu';
import {
    getSymbolForLocale,
} from '../utils/currency';
import MultiColumnMenu from './MultiColumnMenu/MultiColumnMenu';
import Events from './events/CurrencyEvents';

import styles from './CurrencyMenu.scss';

function CurrencyMenu(props) {
    const {
        currentCurrency,
        currentLocale,
        onCurrencyChange = () => undefined,
        supportedCurrencies,
        t,
        vertical,
    } = props;

    const onMenuClick = (navType) => (isOpen) => {
        if (!isOpen) {
            Events.clicked({
                action: 'expand_menu',
                navType,
                selectedCurrency: currentCurrency,
            });
        }
    };

    const onItemSelect = (selectedCurrency) => () => {
        onCurrencyChange(selectedCurrency);
        Events.clicked({
            action: 'select',
            navType: 'hamburger',
            selectedCurrency,
            unselectedCurrency: currentCurrency,
        });
    };

    const renderVerticalMenu = () => {
        return (
            <VerticalMenu
                onToggleMenu={onMenuClick('hamburger')}
                selectedItemIcon={getSymbolForLocale(currentLocale, currentCurrency)}
                selectedItemText={t(`${currentCurrency.toLowerCase()}-currency`)}
            >
                {supportedCurrencies.map((supportedCurrency) => (
                    <VerticalMenuItem
                        icon={getSymbolForLocale(currentLocale, supportedCurrency)}
                        isActive={supportedCurrency === currentCurrency}
                        key={supportedCurrency}
                        onClick={onItemSelect(supportedCurrency)}
                    >
                        <span className={styles.currencyName}>
                            {t(`${supportedCurrency.toLowerCase()}-currency`)}
                        </span>
                    </VerticalMenuItem>
                ))}
            </VerticalMenu>
        );
    };

    const renderThreeColumnMenu = () => {
        return (
            <DropdownMenu
                altText={t('change-lang-currency')}
                onToggleMenu={onMenuClick('nav_bar')}
                title={
                    <div className={styles.currencyTitle}>
                        {getSymbolForLocale(currentLocale, currentCurrency)}
                    </div>
                }
            >
                <MultiColumnMenu
                    currentCurrency={currentCurrency}
                    currentLocale={currentLocale}
                    onCurrencyChange={onCurrencyChange}
                    supportedCurrencies={supportedCurrencies}
                />
            </DropdownMenu>
        );
    };

    return (
        <div className={styles.container}>
            {vertical && renderVerticalMenu()}
            {!vertical && renderThreeColumnMenu()}
        </div>
    );
}

CurrencyMenu.propTypes = {
    currentCurrency: PropTypes.string.isRequired,
    currentLocale: PropTypes.string.isRequired,
    onCurrencyChange: PropTypes.func,
    supportedCurrencies: PropTypes.arrayOf(PropTypes.string).isRequired,
    t: PropTypes.func.isRequired,
    vertical: PropTypes.bool,
};

export { CurrencyMenu };
export default localize(CurrencyMenu, ['t'], 'baseApp');
